import { useCallback, useState } from 'react';
import { useTranslation } from '@frontend/i18n';
import { ConfirmEnrollmentApplicationResponse } from '@frontend/payments-care-credit';
import { useCollectPaymentMultiContext } from '../../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEPS } from '../../../../utils/steps';
import { CareCreditEnrollmentStepView, CareCreditEnrollStepNavigationProps } from '../care-credit-enroll.types';

export const CareCreditEnrollGenericNavigation = ({ body: Body }: CareCreditEnrollStepNavigationProps) => {
  const {
    invoice,
    multiStep: { goPrevStep, onCancel, goNextStep },
    setCareCreditEnrollmentStatus,
    setCareCreditMessageType,
  } = useCollectPaymentMultiContext();

  const [view, setView] = useState<CareCreditEnrollmentStepView>(null);

  const { t } = useTranslation('payments');

  const onGoBack = useCallback(() => {
    goPrevStep({
      orStep: PAYMENT_MULTI_STEPS.careCreditEnrollDisclosure,
    });
  }, [goPrevStep]);

  const onEnrollmentAccepted = useCallback(
    (_result: ConfirmEnrollmentApplicationResponse) => {
      if (invoice?.id) {
        goNextStep({
          orStep: PAYMENT_MULTI_STEPS.careCreditCollect,
        });
      } else {
        setView('success');
      }
    },
    [goNextStep, invoice]
  );

  const onEnrollmentDeclined = useCallback(
    ({ message }: ConfirmEnrollmentApplicationResponse) => {
      if (invoice?.id) {
        setCareCreditEnrollmentStatus({
          status: 'declined',
          message:
            message || t('Applicant was unable to prequalify for CareCredit. Please select another collection method.'),
        });
        goPrevStep({
          orStep: PAYMENT_MULTI_STEPS.paymentMethods,
        });
      } else {
        setView('declined');
      }
    },
    [goPrevStep, setCareCreditEnrollmentStatus, invoice]
  );

  const onGoToMessageStep = useCallback(() => {
    setCareCreditMessageType('enrollment-link');
    goNextStep({
      orStep: PAYMENT_MULTI_STEPS.careCreditMessageDisclosure,
    });
  }, [goNextStep]);

  return (
    <Body
      view={view}
      onGoBack={onGoBack}
      onCancel={onCancel}
      onEnrollmentAccepted={onEnrollmentAccepted}
      onEnrollmentDeclined={onEnrollmentDeclined}
      onGoToMessageStep={onGoToMessageStep}
    />
  );
};
